import { render, staticRenderFns } from "./IndustrySolutions.vue?vue&type=template&id=2d53224b&scoped=true&"
import script from "./IndustrySolutions.vue?vue&type=script&lang=js&"
export * from "./IndustrySolutions.vue?vue&type=script&lang=js&"
import style0 from "./IndustrySolutions.vue?vue&type=style&index=0&id=2d53224b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d53224b",
  null
  
)

export default component.exports